import { IGridTile } from "../models"

export function reorderTiles(
    tiles: IGridTile[],
    targetIndex: number,
    oldIndex: number,
    reorderedTileId: number,
    targetTileId: number,
): IGridTile[] {
    const currentTiles = tiles

    if (oldIndex === targetIndex) {
        return currentTiles
    }

    const to = currentTiles.findIndex((tile) => tile.id === targetTileId)
    const from = currentTiles.findIndex((tile) => tile.id === reorderedTileId)

    const newTiles = currentTiles.slice(0)
    newTiles.splice(to, 0, newTiles.splice(from, 1)[0])

    return newTiles
}

export function removeTile(tiles: IGridTile[], tileId: number): IGridTile[] {
    return tiles.filter((tile) => tile.id !== tileId)
}

export function getTileIds(tiles: IGridTile[]): number[] {
    return tiles.map((t) => t.id)
}
